<template>
  <div class="mask">
    <div class="confirm" v-if="!resultFlag">
      <h1>取消预约确认</h1>
      <p>取消预约后，您今日还剩{{resumeCancelNum>0?resumeCancelNum-1:0}}次预约机会</p>
      <div>
        <button class="btn_confirm" @click="ensureCancel">确定</button>
        <button class="btn_cancel" @click="isCancel(false)">取消</button>
      </div>
    </div>
    <div class="content confirm" v-if="resultFlag">
      <h1>友情提示</h1>
      <p>{{errMsg}}</p>
      <div style="text-align: center;">
        <button class="btn_cancel" @click="isCancel(false)">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { order } from '@/apis'
    export default {
      data(){
        return {
          reqIsComplete:true,
          orderNo:this.$route.query.orderNo,
          errMsg:'',
          resultFlag:false
        }
      },
      props:['sendData','resumeCancelNum'],
      computed:mapState({
        openid: state => state.openid,
        patientId: state => state.patientId,
        patientUUID: state => state.patientUUID,
      }),
      methods:{
        // 确认最终取消
        ensureCancel(){
          if(!this.reqIsComplete){
            this.$toast('请勿重复请求！')
            return
          }else{
            this.reqIsComplete = false;
            this.axios.put(order.orderUpdate,{
              orderNo:this.orderNo,
              status:15,
              patientId:this.patientId,
              patientUUID:this.patientUUID,
              transactionId:'', //支付系统回调时需要传送
            }).then((res)=>{
              if(res.data.code!='000000'){
                this.$toast(res.data.message);
                this.resultFlag = true;
                this.errMsg = res.data.message;
              }else{
                this.$toast('取消成功');
                setTimeout(() => {
                  this.wx.closeWindow();
                },2000)

              }
            }).catch((err)=>{
              this.$toast(err)
            })
          }
        },
        isCancel(data){
          this.$emit('isCancelStatus',data);
        }
      }
    }
</script>

<style scoped lang="scss">
  .mask{
    position:absolute;
    left:0;
    top:0;
    z-index:100;
    background:rgba(0,0,0,.5);
    @include width_height_100();
    .confirm{
      background:$bgfff;
      width:270px;
      height:168px;
      border-radius:3px;
      margin:185px auto 0 auto;
      h1{
        height:52px;
        line-height: 52px;
        @include text_font('PingFangSC',17px,550,#333,center);
      }
      p{
        width:230px;
        height:50px;
        line-height: 25px;
        margin:0 auto;
        @include text_font('PingFangSC',17px,normal,#666,center);
      }
      div{
        width:270px;
        height:45px;
        margin-top:20px;
        border-top:1px solid #F0F0F0;
        @include layout_row_root();
        button{
          width:134.5px;
          height:45px;
          line-height:45px;
          border:none;
          background:$bgfff;
          @include layout_row();
          @include text_font('PingFangSC',15px,normal,#999,center);
        }
        .btn_confirm{
          border-right:1px solid #F0F0F0;
        }
        .btn_cancel{
          color:#41B7A7;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/doorHelp/MaskTemp.vue